import React, { useEffect, useRef, useState } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import FormControl from '@mui/material/FormControl'
import Select, { SingleValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import { getPipelinebyMissionApi } from '../../api/pipelineApi'
import { useAsyncOptions } from '../../hooks/useAsyncOptions'
import { createOptionProps } from '../../components/common/CreateOptionMenu'

interface SelectPipelineProps {
  value: string
  onChange: (event: SelectChangeEvent<string>) => void
  MissionId: string
  disabled?: boolean
  disablePortalMenu?: boolean
  onCreateNew?: (search: string) => void
  reloadKey?: number
}

const SelectPipeline: React.FC<SelectPipelineProps> = ({
  value,
  onChange,
  MissionId,
  disabled,
  disablePortalMenu = false,
  onCreateNew,
  reloadKey = 0,
}) => {
  const menu = useExclusiveMenu(!disablePortalMenu)
  const { idmission } = useParams<{ idmission: string; id: string }>()
  const { t } = useTranslation()
  const { data: pipelines, status, retry } = useAsyncOptions(
    async () => {
      const response = await getPipelinebyMissionApi(MissionId, 1, 200)
      return response.pipelines ?? []
    },
    [MissionId, reloadKey],
    Boolean(MissionId)
  )

  const containerRef = useRef<HTMLDivElement | null>(null)


  const options =
    status === 'ready'
      ? (pipelines ?? []).map((Pipeline) => ({
          value: Pipeline._id || '',
          label: Pipeline.PipelineName || '',
        }))
      : []

  const selectedOption = options.find((opt) => opt.value === value) || null

  const handlePipelineChange = (
    selected: SingleValue<{ value: string; label: string }>
  ) => {
    onChange({
      target: { name: 'PipelineId', value: selected ? selected.value : '' },
    } as SelectChangeEvent<string>)
  }

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          value={selectedOption}
          onChange={handlePipelineChange}
          options={options}
          isLoading={status === 'loading'}
          isDisabled={(disabled ?? !!idmission) || status === 'loading' || !MissionId}
          placeholder={
            !MissionId
              ? t('actionImport.context.pickMissionFirst')
              : status === 'loading'
                ? t('selectOptions.loading')
                : t('Pipeline', 'Pipeline')
          }
          noOptionsMessage={() =>
            !MissionId
              ? t('actionImport.context.pickMissionFirst')
              : status === 'error'
                ? t('selectOptions.failed')
                : t('tables.noData')
          }
          {...menu}
          styles={incyiaSelectStyles}
          isMulti={false}
          {...createOptionProps(
            onCreateNew && MissionId
              ? { label: t('quickCreate.new.pipeline'), onCreate: onCreateNew }
              : undefined
          )}
        />
      </FormControl>
      {status === 'error' ? (
        <button
          type="button"
          onClick={retry}
          style={{
            marginTop: 6,
            background: 'none',
            border: 'none',
            padding: 0,
            color: '#076B5C',
            cursor: 'pointer',
            fontFamily: 'Lato, sans-serif',
            fontSize: 13,
          }}
        >
          {t('selectOptions.retry')}
        </button>
      ) : null}
    </div>
  )
}

export default SelectPipeline
